import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class AuthorityService {
    private resourceUrl = 'api/authorities';

    constructor(private http: Http) {
    }

    getAllAuthorities(): Observable<Response> {
        return this.http.get(this.resourceUrl);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/user/authority.service.ts